"use client";

import Image from "next/image";
import styles from "./partners.module.css";

const logos = [
    { src: "/assets/images/partners/british-embassy.png", alt: "British Embassy" },
    { src: "/assets/images/partners/us-embassy.png", alt: "US Embassy" },
    { src: "/assets/images/partners/australian-government.png", alt: "Australian Government" },
    { src: "/assets/images/partners/georgia-adventure-club.png", alt: "Georgia Adventure Club" },
    { src: "/assets/images/partners/government-of-georgia.png", alt: "Government of Georgia" },
    { src: "/assets/images/partners/your-sixth-logo.png", alt: "Partner organization" },
];

export default function Partners() {
    return (
        <section className={styles.partners}>
            <h2 className={styles.title}>Our Partners</h2>
            <div className={styles.scroller}>
                {logos.map(({ src, alt }) => (
                    <div key={src} className={styles.slide}>
                        <Image
                            src={src}
                            alt={alt}
                            width={1}
                            height={1}
                            unoptimized
                            style={{
                                maxHeight: "144px",
                                width: "auto",
                                height: "auto",
                            }}
                        />
                    </div>
                ))}
            </div>
        </section>
    );
}
